export const BLOB_CONFIG = {
  background: '#ffffff',
  gradientMap: '1',
  gradientColor1: '#ffb3ba',
  gradientColor2: '#bae1ff',
  gradientColor3: '#b8e6b8',
  uPositionFrequency: 0,
  uPositionStrength: 0.46,
  uSmallWavePositionFrequency: 0.81,
  uSmallWavePositionStrength: 0.51,
  uSmallWaveTimeFrequency: 0.2,
  uTimeFrequency: 0.26,
  roughness: 0,
  metalness: 1,
  envMapIntensity: 5,
  clearcoat: 0,
  clearcoatRoughness: 1,
  transmission: 1,
  wireframe: true,
  flatShading: false,
  autoRotate: false,
  autoRotateSpeed: 9.8,
};
